import React from 'react';
import { navigate } from 'gatsby';
import { connect } from 'react-redux';
import { mapStateToProps, mapDispatchToProps } from '../Store';
import Layout from '../components/layouts/Layout';
import SEO from '../components/seo';
import { isBrowser } from '../utils/';
import LoginForm from '../components/login/login_form';
import promotion from '../../promotion_config';
import Error from '../components/login/error';


export const Login = ({ user, notification, actions }) => {
    if (isBrowser() && user.loggedIn) {
        navigate('/enter');
    }

    return (
        <Layout user={user} notification={notification} actions={actions}>
            <SEO title="Log In" />
            <div className="content-container login">
                <div className="row">
                    <div className="col-md-10 col-md-offset-1">
                        <LoginInner user={user} actions={actions} />
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export const LoginInner = ({ user, actions }) => {
    return (
        <>
            <h1>Log In</h1>
            <div className="row">
                <div className="col-xs-12">
                    <Error user={user} actions={actions} />
                </div>
            </div>
            <div className="row">
                <div className="col-xs-12">
                    <LoginForm user={user} actions={actions} />
                </div>
            </div>
            <div className="row">
                <div className="register-now col-xs-12 text-center my-5">
                    <a
                        className="text-center register-now"
                        href={promotion.registerLink}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Not Registered Yet?
                        <br />
                        Register
                    </a>
                </div>
            </div>
        </>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
